import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { PartnerOffersData, PartnerOffersSelectionData } from "./partnerOfferTypes";

const PARTNER_OFFERS_URL = "api/formations/partner-offers";

export interface IPartnerOffersClient {
  getOffers: () => Promise<PartnerOffersData>;
  // Replaces the whole selection - an empty list means the customer picked nothing.
  saveSelection: (offerIds: string[]) => Promise<PartnerOffersData>;
}

export class PartnerOffersClient implements IPartnerOffersClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async getOffers(): Promise<PartnerOffersData> {
    const response = await this._apiClient.get(PARTNER_OFFERS_URL);
    return response.getData(PartnerOffersData);
  }

  async saveSelection(offerIds: string[]): Promise<PartnerOffersData> {
    const response = await this._apiClient.put(PARTNER_OFFERS_URL, new PartnerOffersSelectionData({ offerIds }));
    return response.getData(PartnerOffersData);
  }
}
